import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { useTranslation } from "react-i18next";
import { useRptCa } from '../../../../St/Reviews/UseStyle';
import { Box, Paper, Typography } from "@material-ui/core";
import { reFormatDate, reFormatTime } from "../../../../utils/utils";
import { styleFooterNotesAr } from "../../../Invs/ShareFunctionsPrint";
export function Totals({ infoData }) {

    const { t } = useTranslation(["forms"]);

    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleTo = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.8rem",
        fontWeight: "bold",
    };
    return (
        <Grid item container >
            <Grid item container style={{ fontFamily: "Amiri-Regular", marginBottom: "0.5rem", marginTop: "0.7rem" }}>
                <Grid item xs={7} style={styleE}>
                    {'صافي نقدي'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totRsedStok?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'صافي الشبكة'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totRsedNetW?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'صافي البنك'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totBanks?.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleE}>
                    {'صافي الاجل'}
                </Grid>
                <Grid item xs={5} style={styleE}>
                    {infoData.tot.totAgels?.toFixed(2)}
                </Grid>
                {infoData?.is_comm &&
                    <>
                        <Grid item xs={7} style={styleE}>
                            {"اجمالي التحصيلات"}
                        </Grid>
                        <Grid item xs={5} style={styleE}>
                            {infoData.total_naqed.toFixed(2)}
                        </Grid>
                        <Grid item xs={7} style={styleE}>
                            {"عمولة التحصيل"}
                        </Grid>
                        <Grid item xs={5} style={styleE}>
                            {infoData.comm_receipt.toFixed(2)}
                        </Grid>
                    </>
                }
            </Grid>
        </Grid>
    );
}



function BodyGroups({ infoData }) {
    const { t } = useTranslation(["forms", "translation"]);
    const cls = useRptAF();
    const clas = useRptCa();

    const groups = infoData.dataGroups.reduce((acc, item) => {
        const key = item.group_id;

        if (!acc[key]) {
            acc[key] = {
                groupId: item.group_id,
                groupName: item.group_name,
                items: [],
            };
        }
        acc[key].items.push(item);
        return acc;
    }, {});
    const groupsData = Object.values(groups);
    const cellS = {

        padding: "0px 0.1px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "1.1rem",
        width: "250px",
        textAlign: "right",
        paddingRight: "0.85rem",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem"
    };

    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.85rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleE2 = {
        textAlign: "center",
        fontSize: "1rem",
        color: "black",
        fontWeight: "bold",
    };
    return (
        <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
            <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>

                <Grid item container className={clas.Bdycntr}>
                    <Grid item container style={{ justifyContent: 'center', }}>
                        <Grid item xs={4} style={styleE2} >{'من تاريخ'}</Grid>
                        <Grid item xs={8} style={styleE2} >{reFormatDate(infoData.fDate)} {"  "} {reFormatTime(infoData.fDate)}</Grid>
                        <Grid item xs={4} style={styleE2}>{'إلى تاريخ'}</Grid>
                        <Grid item xs={8} style={styleE2}>{reFormatDate(infoData.tDate)} {"  "} {reFormatTime(infoData.tDate)}</Grid>
                    </Grid>
                </Grid>

                <Grid container xs={12}>

                    <Grid item xs={6} style={styleE}>
                        {infoData?.kind == 2 ? "نوع الحركة" : "رقم الوردية"}
                    </Grid>
                    <Grid item xs={6} style={styleE}>
                        {infoData?.kind == 2 ? "الاجمالي" : infoData.transNo}
                    </Grid>

                </Grid>
                {groupsData?.map((d) => (
                    <Grid container item xs={12}
                        key={d.groupId}
                    // sx={{ mb: 3, p: 2 }}
                    >
                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            color="primary"
                            sx={{ md: 1 }}
                            style={{
                                border: "1px solid #eee",
                                textAlign: "center",
                                textAlign: "center",
                                width: "100%",
                                marginTop: "0.3rem"
                            }}
                        >
                            {d.groupName}
                        </Typography>
                        <Grid container item xs={12}
                            sx={{
                                border: "1px solid #eee",
                                fontWeight: "bold",
                                display: "flex",
                                pb: 1,
                                md: 1,
                                width: "100%"
                            }}>
                            <Grid item xs={6} style={styleE} sx={{ flex: 4 }}> {"الصنف"}</Grid>
                            <Grid item xs={3} style={styleE} sx={{ flex: 1 }}> {"الكمية"}</Grid>
                            <Grid item xs={3} style={styleE} sx={{ flex: 1 }}> {"الاجمالي"}</Grid>

                        </Grid>
                        {d.items.map(item => (
                            <Grid container item xs={12}
                                key={item.item_id}
                                sx={{
                                    display: "flex",
                                    width: "100%",
                                    py: 1,
                                    border: "1px solid #eee", "&:hover": {
                                        bgColor: "#f5f5f5"
                                    }
                                }}>
                                <Grid item xs={6} style={styleE} sx={{ flex: 4 }}> {item.item_name}</Grid>
                                <Grid item xs={3} style={styleE} sx={{ flex: 1 }}> {item.quan}</Grid>
                                <Grid item xs={3} style={styleE} sx={{ flex: 1 }}> {item.total}</Grid>

                            </Grid>
                        ))}

                    </Grid>
                ))}
                {<Totals infoData={infoData} />}

            </Grid>
            {infoData?.kind == 2 &&
                <Grid item xs={12} className={"invoice-footerar"}
                    style={styleFooterNotesAr} >
                    {infoData?.notes}
                </Grid>
            }

        </Grid>
    );
}

export default BodyGroups;
